import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Grow, Popper, IconButton, Paper } from "@mui/material";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import Comment$ from "@mui/icons-material/Comment";

export function InvoicePopup(entry) {
    let elements;
    const patternInput = reactApi.useState(undefined);
    const setAnchor = patternInput[1];
    const anchor = patternInput[0];
    const isOpen = anchor != null;
    const id = (anchor != null) ? (`order-${entry.OrderNo}-invoice-comment-popper`) : defaultOf();
    const commentText = createElement("blockquote", {
        style: {
            whiteSpace: "pre-wrap",
            maxWidth: 120 + "ch",
            marginLeft: 15 + "px",
            paddingLeft: 10 + "px",
            borderLeft: ((((3 + "px") + " ") + "solid") + " ") + "rgba(225, 225, 225, 1)",
        },
        children: entry.InvoiceComment,
    });
    const commentBox = MuiHelpers_createElement(Paper, [["sx", {
        p: 1,
    }], (elements = [MuiHelpers_createElement(ClickAwayListener, [["onClickAway", (arg) => {
        console.debug("[CustomerHistory] ClickAwayListener onClickAway:", arg);
        setAnchor(undefined);
    }], ["children", commentText]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    const xs_1 = [MuiHelpers_createElement(IconButton, toList(delay(() => append(singleton(["id", `order-${entry.OrderNo}-invoice-comment-button`]), delay(() => append(singleton(["onClick", (ev) => {
        setAnchor((anchor != null) ? undefined : ev.currentTarget);
    }]), delay(() => append(isOpen ? singleton(["color", "success"]) : empty(), delay(() => append(singleton(["size", "small"]), delay(() => {
        let props_6;
        return singleton(["children", (props_6 = {}, react.createElement(Comment$, props_6))]);
    }))))))))))), MuiHelpers_createElement(Popper, [["id", id], ["open", isOpen], ["anchorEl", anchor], ["transition", true], ["children", (props_3) => MuiHelpers_createElement(Grow, toList(delay(() => append(Object.entries(props_3.TransitionProps), delay(() => singleton(["children", commentBox]))))))]])];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

